import React from 'react';
import { Box, Typography } from '@mui/material';

import { IAvailableCandidate } from '@types';
import { allocationNote, availabilityOf } from '@utils';
import { availabilityDotColor } from 'theme/availability';
import { DotValue } from 'components/common/RankingValue/DotValue';

export const AvailableFromCell: React.FC<{
  candidate: IAvailableCandidate;
}> = ({ candidate }) => {
  const { label, tone } = availabilityOf(candidate);
  const secondLine = allocationNote(candidate);

  if (!label && !secondLine) return null;

  return (
    <Box display="flex" flexDirection="column" minWidth={0}>
      {Boolean(label) && (
        <DotValue color={(palette) => availabilityDotColor(palette)[tone]}>
          {label}
        </DotValue>
      )}
      {Boolean(secondLine) && (
        <Typography
          variant="caption"
          color="text.secondary"
          ml={label ? 2 : 0}
          noWrap
        >
          {secondLine}
        </Typography>
      )}
    </Box>
  );
};
